import React from 'react';
import { AutocompleteRenderOptionState, Box, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import {
  AsyncAutocomplete,
  AutocompleteHighlighter,
} from '../Inputs/AutocompleteInput';
import { formatUserFullName, isHigherEdAdmin } from '@uplift/utils';
import { useCurrentuser } from '@uplift/contexts';
import { useUserSearch } from '../Layout/AdminLayout/AdminSearch/user-search.hook';
import { UserSearch } from '../Layout/AdminLayout/AdminSearch';
import { Chip } from '../Chip';

const NameHighlighter = withStyles(AutocompleteHighlighter, theme => ({
  highlight: {
    fontWeight: 600,
    color: theme.palette.secondary.main
  }
}));

export const userAutocompleteRenderItem = (option: UserSearch, state: AutocompleteRenderOptionState) => (
  <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" flex="1">
    <Typography>
      <NameHighlighter
        text={`${option.firstName}${option.preferredName ? ' (' + option.preferredName + ')' : ''} ${option.lastName}`}
        highlight={state.inputValue}
      />
    </Typography>
    {!option.active && <Chip label="Inactive" variant="filled" color="default" size="small" />}
  </Box>
);

export const AdminSearchAutocomplete: React.VFC<{
  name: string;
  label?: string;
  autoFocus?: boolean;
  placeholder?: string;
  disablePortal?: boolean;
  ['data-testid']?: string;
}> = (props) => {
  const me = useCurrentuser();
  const isHigherEdAdminRole = isHigherEdAdmin(me);
  const searchUsers = useUserSearch(isHigherEdAdminRole);

  return (
    <AsyncAutocomplete
      data-testid={props?.['data-testid']}
      forcePopupIcon={false}
      fullWidth
      blurOnSelect
      clearOnBlur
      disablePortal={props.disablePortal}
      openWithNoTerm={true}
      noOptionsText="No results"
      name={props.name}
      renderOption={userAutocompleteRenderItem}
      getOptionLabel={option => typeof option === 'object' ? formatUserFullName({ firstName: option.firstName, lastName: option.lastName, preferredFirstName: option.preferredName }) : option}
      asyncOptions={async (term) => await searchUsers(term)}
    />
  );
};
